import { render, staticRenderFns } from "./TranslationTopBar.vue?vue&type=template&id=185e7cb7&scoped=true"
import script from "./TranslationTopBar.vue?vue&type=script&lang=ts"
export * from "./TranslationTopBar.vue?vue&type=script&lang=ts"
import style0 from "./TranslationTopBar.vue?vue&type=style&index=0&id=185e7cb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e7cb7",
  null
  
)

export default component.exports